<template>
  <div
    id="farmapremium-settings-shell"
    v-bind="$attrs"
  />
  <modal-base
    v-if="!isLoaded"
    :model-value="isOpen"
    show-loading-spinner
    fixed-height="803px"
    padding-size="none"
    size="lg"
    scrollable
    loader
  />
</template>

<script>
import { useMicros } from '@/composables'
import * as config from '@/dashboards'
import { Channel, piniaStoreModules } from 'frontendcommon-3'
import { storeToRefs, getActivePinia } from 'pinia'
import { useShellStore } from '@/store'

let isLoaded = false

export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    settings: {
      type: String,
      default: ''
    }
  },
  emits: [
    'update:modelValue',
    'update:settings'
  ],
  setup () {
    // shell store
    const shellStore = useShellStore()
    const { tokens, userInfo } = storeToRefs(shellStore)

    // common store
    const pinia = getActivePinia()
    const commonStore = piniaStoreModules.useCommon(pinia)
    const commonState = commonStore.$state

    const micro = useMicros()
    return { micro, tokens, userInfo, commonState }
  },
  data () {
    return {
      isMounted: false,
      isOpen: this.modelValue,
      preventAnimation: !isLoaded,
      isLoaded
    }
  },
  computed: {
    modalClass () {
      return {
        'store-settings-modal': 1,
        'prevent-animation': this.preventAnimation
      }
    }
  },
  watch: {
    settings (val) {
      this.$settings && this.$settings.set({ modelValue: this.isOpen, settings: val })
    },
    modelValue (val) {
      this.isOpen = val
    },
    async isOpen (val) {
      val && await this.mountMicro()
      this.$settings && this.$settings.set({ modelValue: val, settings: this.settings })
    },
    modalClass (classes) {
      this.$settings && this.$settings.set({ classes })
    }
  },
  methods: {
    async mountMicro () {
      try {
        if (!isLoaded) {
          await this.micro.loadMicro('settingsShell', true)
          isLoaded = true
        }
        if (!this.isMounted) {
          // Create controller instance
          this.$settings = new window.SettingsShell({
            modelValue: this.modelValue,
            classes: this.modalClass
          }).on('update:modelValue', (val) => {
            this.$emit('update:modelValue', val)
          }).on('update:settings', (val) => {
            this.$emit('update:settings', val)
          })
          // Mount component
          await this.$settings.mount(
            '#farmapremium-settings-shell',
            { ...this.commonState, requestLang: this.userInfo.requestLang },
            this.tokens,
            config
          )
          this.isMounted = true
          setTimeout(() => { this.preventAnimation = false }, 1000)
        }
      } catch (error) {
        this.isOpen = false
        Channel.emitAddServerError('No se ha podido cargar el panel de configuración.')
        console.error(error)
      }
    }
  },
  beforeUnmount () {
    this.$settings && this.$settings.destroy()
    this.$settings = null
  }
}
</script>

<style lang="scss">
.store-settings-modal.prevent-animation {
  > div {
    transition: none !important;
    transform: translateY(0px) !important;
    opacity: 1 !important;
  }
}
</style>
